import { useEffect, useState } from 'react';
import { phaseApi } from '../services/api';

// Lightweight singleton cache of the phase list (slug/title/order_index),
// used to turn a control's "Used in" phase titles into real links to
// /phases/:slug without every cockpit component re-fetching /api/phases.
let cachedPhases = null;
let inflightPromise = null;

const fetchPhases = () => {
  if (cachedPhases) return Promise.resolve(cachedPhases);
  if (!inflightPromise) {
    inflightPromise = phaseApi.getAll().then((res) => {
      cachedPhases = res.data;
      return cachedPhases;
    });
  }
  return inflightPromise;
};

export const usePhaseList = () => {
  const [phases, setPhases] = useState(cachedPhases || []);

  useEffect(() => {
    if (cachedPhases) {
      setPhases(cachedPhases);
      return;
    }
    let active = true;
    fetchPhases().then((p) => {
      if (active) setPhases(p);
    }).catch(() => {});
    return () => {
      active = false;
    };
  }, []);

  const slugByTitle = {};
  phases.forEach((p) => {
    slugByTitle[p.title] = p.slug;
  });

  return { phases, slugByTitle };
};
